<template>
  <div>
    <BbCropper
									name="image"
									:img="getUrl"
									:action="parent.clipUploadAPI"
									:autoCropWidth="imageConfig.width"
									:autoCropHeight="imageConfig.height"
									:on-success="parent.cropperSuccess"
									:on-remove="(val)=>parent.cropperRemove(val,keyString)"
									:headers="routerInfo"
									:key-string="keyString"
                  :fixedBox="imageConfig.fixedBox==undefined?true:imageConfig.fixedBox"
									>
								</BbCropper>
        <!-- <bb-upload :data="{file_ident:ident}"
                  :action="parent.baseAPI"
                  :accept="accept"
                  upload-type="single"
                  link
                  :file-list="parent.ruleForm[keyString]"
                  :on-remove="parent.removeSingleUpload"
                  :on-success="parent.successSingleUpload"
                  :before-upload="(file)=>parent.imageUploadBefore(file,ident)"
                  :key-string="keyString"> -->
          <div slot="tip" class="tip">
            {{ `规格${imageConfig.width}*${imageConfig.height}  大小${imageConfig.size}KB以内`}}
          </div>
        <!-- </bb-upload> -->
  </div>
  
</template>

<script>
/* eslint-disable */
// import BbUpload from "@/components/BbUpload";
import BbCropper from "@/components/BbCropper";

export default {
  components: {
    BbCropper
  },
  props: {
    ident:{
      type:String,
      required:true
    },
    accept:{
      type:String,
      default:"image/png"
    },
    keyString:{
      type:String,
      required:true
    },
    parent:{
      type:Object,
      required:true
    },
    CustomImageConfig:{
      type:Object,
      required:false
    },
  },
  data() {
    return {
      // autoconfig的 这个文件使用
      routerInfo:
        this.$route.name == "SA_PBaseIndex" ||
        this.$route.name == "SA_DBaseIndex"
          ? this.$store.state.common.routerInfo
          : { routerName: this.$route.name, routerPath: this.$route.path },
    };
  },
  computed:{
    imageConfig(){
      if(this.CustomImageConfig){
        return this.CustomImageConfig
      }
      let temp = this.parent.imageConfig[this.ident]
      if(temp){
        return temp[0]
      }else{
        return {}
      }
    },
    getUrl(){
      const result = this.parent.ruleForm[this.keyString]
      return result[0]?result[0].url:""
    },
    
  }

};
</script>

<style scoped>
.tip{
  text-align: left;
    line-height: 18px;
    color: #aaa;

    font-size: 12px;
}
</style>
